const inicialState = {
  laudoSelecionado: { laudo: 0, etapas: [] }
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/relatorio/relatorio.state.js